import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';

import { CompactPicker } from 'react-color';

import Title from '../../../components/Title';
import ContentsPreviewMobile from './ContentsPreviewMobile';
import ContentsPreviewH from './ContentsPreviewH';
import ContentsPreviewV from './ContentsPreviewV';
import {
  getContentsDetail,
  getSlideList,
} from '../../../modules/NetworkFunction';
import AuthContext from '../../../contexts/AuthContext';
import DrawerContents from '../../../components/DrawerContents';
import closeIcon from '../../../icons/ic-close.png';

import radius0 from '../../../icons/ic-radius0-default.png';
import radius0Check from '../../../icons/ic-radius0-checked.png';
import radius10 from '../../../icons/ic-radius10-default.png';
import radius10Check from '../../../icons/ic-radius10-checked.png';
import radius50 from '../../../icons/ic-radius50-default.png';
import radius50Check from '../../../icons/ic-radius50-checked.png';
import { getUserDetail, getInicisPayment } from '../../../modules/NetworkFunction';
import ShopModeContext from '../../../contexts/ShopModeContext';

const FONT_STYLES = ['심플한', '힙한', '감성적인', '세리프', '발랄한'];
const FONT_FAMILIES = {
  심플한: ['Noto Sans', 'Gmarket Sans'],
  힙한: ['HSJiptokki', 'BM HANNA 11yrs old'],
  감성적인: ['Chosun Centennial', 'Cafe24 Oneprettynight'],
  세리프: ['Cafe24 ClassicType', 'Cafe24 Danjunghae'],
  발랄한: ['BM JUA', 'Cafe24 Syongsyong'],
};
const FONT_FAMILIES_CODE = {
  'Noto Sans': 'Noto Sans KR',
  'Gmarket Sans': 'GmarketSansMedium',
  HSJiptokki: 'HSJiptokki-Black',
  'BM HANNA 11yrs old': 'Hanna',
  'Chosun Centennial': 'ChosunCentennial',
  'Cafe24 Oneprettynight': 'Cafe24Oneprettynight',
  'Cafe24 ClassicType': 'Cafe24ClassicType-Regular',
  'Cafe24 Danjunghae': 'Cafe24Danjunghae',
  'BM JUA': 'BMJUA',
  'Cafe24 Syongsyong': 'Cafe24Syongsyong',
};

const BUTTON_RADIUS = [
  {
    label: '날카로운(0%)',
    image: {
      default: radius0,
      selected: radius0Check,
    },
  },
  {
    label: '살짝 둥근(10%)',
    image: {
      default: radius10,
      selected: radius10Check,
    },
  },
  {
    label: '아주 둥근(50%)',
    image: {
      default: radius50,
      selected: radius50Check,
    },
  },
];

const DesignPreviewPage = (props) => {
  const {
    closeModal,
    setPreviewModalClose,
    contentsNo,
    publishedContents = [],
    contentStyle,
    selectedfontStyle = 0,
    onSelectSelectedFontStyle,
    margin,
    onSelectMargin,
    selectedFontFamily = 'Noto Sans KR',
    onSelectSelectedFontFamily,
    shopVersion,
    isPaid,
    selectedRadiusIdx = 0,
    onSelectSelectedRadiusIdx,
    fontColor = '#ffffff',
    onSelectFontColor,
    btnColor = '#000',
    onSelectBtnColor,
  } = props;
  const { auth: token } = useContext(AuthContext);
  const { shopMode } = useContext(ShopModeContext);

  const [isNextStage, setIsNextStage] = useState(false);
  const [isInicisPaid, setIsInicisPaid] = useState(false);
  const [userData, setUserData] = useState();


  const [contentType, setContentType] = useState(
    contentStyle
      ? contentStyle
      : contentsNo && publishedContents[0]
      ? publishedContents[0].style
      : '배너 가로'
  );

  const [isMobile, setIsMobile] = useState(
    shopVersion
      ? shopVersion === 'mobile'
      : contentsNo && publishedContents[0]
      ? publishedContents[0].mobileYn
      : false
  );
  const [videoUrl, setVideoUrl] = useState();
  const [btnBorderRadius, setBtnBorderRadius] = useState(0);
  const [slideList, setSlideList] = useState([]);
  const [font, setFont] = useState(
    selectedFontFamily ? selectedFontFamily : 'Noto Sans KR'
  );

  const contents = { contentsNo: contentsNo };
  console.log('isPaid', isPaid);
  console.log('isInicisPaid', isInicisPaid);
  console.log('nextStage', isNextStage);

  const onClickFontButton = (index) => {
    onSelectSelectedFontStyle(index);
  };

  const handleCloseModal = () => {
    setIsNextStage(false);
    closeModal();
  };

  const handleMarginChange = (e) => {
    const value = e.target.value;
    if (e.target.value < 0 || e.target.value > 100) {
      alert('0~100 사이의 값을 입력해주세요.');
    } else {
      onSelectMargin(value);
    }
  };

  const onButtonColorChange = (e) => {
    onSelectBtnColor(e.hex);
  };

  const onFontColorChange = (e) => {
    onSelectFontColor(e.hex);
  };

  useEffect(() => {
    if (contentsNo) {
      getContentsDetail(
        contents,
        (e) => {
          console.log(e);
          setVideoUrl(e.videoURL);
        },
        () => {},
        (e) => {
          console.log(e);
        },
        token
      );
      getSlideList(
        contents,
        (error) => {
          console.log(error);
        },
        token
      ).then((response) => {
        setSlideList(
          response.data.slideList.sort((a, b) => a.displayTime - b.displayTime)
        );
      });
    }
    // 콘텐츠 만들기에서 미리보기
    else {
      setVideoUrl(props.videoUrl);
      setSlideList(props.slideList);
    }
  }, []);

  useEffect(() => {
    if (selectedRadiusIdx === 0) {
      setBtnBorderRadius(0);
    } else if (selectedRadiusIdx === 1) {
      setBtnBorderRadius(10);
    } else {
      setBtnBorderRadius(50);
    }
  }, [selectedRadiusIdx]);

  useEffect(() => {
    getUserDetail(
      null,
      (v) => {
        setUserData(v.user);
      },
      () => {},
      (e) => {
        console.log('getuserdetail', e);
      },
      token
    );
  }, [token]);

  useEffect(() => {
    getInicisPayment(
      {
        userNo: userData?.userNo
      },
      (v) => {
        console.log(v);
        if (v.payment.length > 0){
          setIsInicisPaid(true)
        } else {
          setIsInicisPaid(false)
        }
      },
      () => {},
      (error) => {
        console.error(error);
      },
      token
    )

  }, [userData, token])

  const previewMobile = (
    <div className="phone">
      <ContentsPreviewMobile
        key={contentType}
        videoUrl={videoUrl}
        slideList={slideList}
        btnColor={btnColor}
        fontColor={fontColor}
        font={selectedFontFamily}
        btnBorderRadius={btnBorderRadius}
        contentsStyle={contentType}
        margin={margin}
      />
    </div>
  );

  const previewPC = (
    <div className="pc-preview">
      <div className="tab-bar"></div>
      <div
        className="pc-view"
        style={{
          backgroundColor: contentType.includes('팝업')
            ? 'rgba(0, 0, 0, 0.5)'
            : '#fff',
        }}
      >
        <div className="header">
          <p>W i z m o n</p>
          <div className="navbar">
            <ul>
              <li>NEW</li>
              <li>Coat</li>
              <li>Jacket</li>
              <li>Dress</li>
              <li>Sweater</li>
              <li>Top</li>
              <li>Pants</li>
              <li>Acc</li>
            </ul>
          </div>
        </div>
        <div className="main">
          <div
            className={
              contentType.includes('세로')
                ? 'contents-vertical'
                : 'contents-horizontal'
            }
            style={{
              position: 'relative',
              height: '100%',
              marginTop: contentType.includes('팝업 세로') ? '70px' : '0',
            }}
          >
            {contentType.includes('가로') && (
              <ContentsPreviewH
                videoUrl={videoUrl}
                slideList={slideList}
                btnColor={btnColor}
                fontColor={fontColor}
                font={selectedFontFamily}
                btnBorderRadius={btnBorderRadius}
                margin={margin}
                contentType={contentType}
              />
            )}
            {contentType.includes('세로') && (
              <ContentsPreviewV
                videoUrl={videoUrl}
                slideList={slideList}
                btnColor={btnColor}
                fontColor={fontColor}
                font={selectedFontFamily}
                btnBorderRadius={btnBorderRadius}
                margin={margin}
                contentType={contentType}
              />
            )}
            {contentType === '서랍형' && (
              <DrawerContents
                videoUrl={videoUrl}
                slideList={slideList}
                btnColor={btnColor}
                fontColor={fontColor}
                font={selectedFontFamily}
                btnBorderRadius={btnBorderRadius}
                margin={margin}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );

  const freeVersion = (
    <div className="version-select-container" style={{ width: 243 }}>
      <div className="pc-version-container">
        <div className="version-title">폰트 스타일</div>
        <ButtonContainer>
          {FONT_STYLES.map((fontStyle, index) => {
            return (
              <Button
                selected={selectedfontStyle === index}
                key={fontStyle}
                onClick={() => onClickFontButton(index)}
                align={true}
                type={'button'}
              >
                {' '}
                {fontStyle}
              </Button>
            );
          })}
        </ButtonContainer>
      </div>
      <div className="pc-version-container">
        <div className="version-title">폰트</div>
        <FontFamilyContainer>
          {FONT_FAMILIES[FONT_STYLES[selectedfontStyle]].map((fontFamily) => {
            console.log(fontFamily, selectedFontFamily);
            return (
              <Button
                selected={FONT_FAMILIES_CODE[fontFamily] === selectedFontFamily}
                key={fontFamily}
                onClick={() =>
                  onSelectSelectedFontFamily(FONT_FAMILIES_CODE[fontFamily])
                }
                type={'button'}
              >
                {fontFamily}
              </Button>
            );
          })}
        </FontFamilyContainer>
      </div>
      {!contentType.includes('팝업') && (
        <div className="pc-version-container">
          <div className="version-title">마진</div>
          <div style={{ display: 'flex', gap: '11px', alignItems: 'center' }}>
            <Input
              placeholder="수치를 직접 입력해주세요."
              value={margin}
              onChange={handleMarginChange}
            ></Input>
            <div
              style={{
                color: '#848484',
                fontFamily: 'Noto Sans',
                fontSize: '20px',
                fontWeight: '400',
              }}
            >
              px
            </div>
          </div>
        </div>
      )}
    </div>
  );

  const paidVersion = (
    <div className="version-select-container" style={{ width: 250 }}>
      <div className="pc-version-container">
        <div className="version-title">폰트 컬러</div>
        <ColorPickerHeader>
          <ColorPreview backgroundColor={fontColor} />
          <ColorInput type="text" maxLength="7" value={fontColor} readOnly />
        </ColorPickerHeader>
        <CompactPicker
          width="100%"
          color={fontColor}
          disableAlpha={true}
          onChange={onFontColorChange}
        />
      </div>
      <div className="pc-version-container">
        <div className="version-title">버튼 컬러</div>
        <ColorPickerHeader>
          <ColorPreview backgroundColor={btnColor} />
          <ColorInput type="text" maxLength="7" value={btnColor} readOnly />
        </ColorPickerHeader>
        <CompactPicker
          color={btnColor}
          disableAlpha={true}
          onChange={onButtonColorChange}
        />
      </div>
      <div className="pc-version-container">
        <div className="version-title">곡률</div>
        <div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'row',
              marginTop: 15,
            }}
          >
            {BUTTON_RADIUS.map((button, idx) => {
              return (
                <RadiusButton
                  key={button.label}
                  onClick={() => onSelectSelectedRadiusIdx(idx)}
                  selected={selectedRadiusIdx === idx}
                >
                  <img
                    src={
                      selectedRadiusIdx === idx
                        ? button.image.selected
                        : button.image.default
                    }
                    alt={button.label}
                  />
                  {button.label}
                </RadiusButton>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="preview-page-modal">
      <div
        style={{
          width: '90%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
        }}
      >
        <Title title="미리보기" style={{ paddingTop: 66 }} />
        <CloseButton onClick={handleCloseModal} />

        {!isNextStage ? freeVersion : paidVersion}
        {isMobile ? previewMobile : previewPC}
      </div>

      <RoundButtonContainer>
        {(shopMode ==='cafe24?'? isPaid:isInicisPaid) ? (
          <RoundButton
            backgroundColor={!isNextStage ? '#B5B5B5' : '#FFB600'}
            color="#fff"
            onClick={() =>
              !isNextStage ? setIsNextStage(true) : handleCloseModal()
            }
          >
            {!isNextStage ? '다음으로' : '계속하기'}
          </RoundButton>
        ) : (
          <RoundButton
            backgroundColor="#FFB600"
            color="#fff"
            onClick={() => handleCloseModal()}
          >
            계속하기
          </RoundButton>
        )}
      </RoundButtonContainer>
    </div>
  );
};

const RoundButtonContainer = styled.div`
  position: absolute;
  bottom: 30px;
  right: 45px;
  display: flex;
  justify-content: 'flex-end';
`;

const RoundButton = styled.div`
  display: flex;
  padding: 10px 30px;
  text-align: center;
  border-radius: 50px;
  font-size: 20px;
  font-weight: 700;
  border-width: 0;
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.color};
  cursor: pointer;
  align-items: center;
`;

const ButtonContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  justify-items: ${({ align }) => (align ? 'end' : 'start')};
`;

const Button = styled.button`
  display: flex;
  justify-content: ${({ align }) => (align ? 'center' : 'flex-start')};
  align-items: center;
  width: 100%;
  height: 40px;
  padding: ${({ align }) => (align ? '7px 0' : '7px 22px')};
  border-radius: 5px;
  color: ${({ selected }) => (selected ? '#ffffff' : '#B5B5B5')};
  background-color: ${({ selected }) => (selected ? 'orange' : 'white')};
  font-size: 16px;
  box-shadow: ${({ selected }) =>
    selected ? 'none' : '0 0 0 1px #B5B5B5 inset'};
  cursor: pointer;
  border-width: 0;
`;

const FontFamilyContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: 'flex-start';
  align-items: 'center';
  flex-direction: column;
`;

const Input = styled.input`
  width: 100%;
  margin: 0px;
  min-width: 0;
  display: block;
  padding: 8px 8px;
  font-size: 18px;
  line-height: inherit;
  border: 1px solid;
  border-radius: 5px;
  color: #c4c4c4;
  background-color: transparent;
  border-color: #c4c4c4;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  background-repeat: no-repeat;
  background-position: calc(100% - 10px) center;

  &::placeholder {
    color: #c4c4c4;
    font-family: 'Noto Sans';
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 24px;
  right: -60px;
  width: 32px;
  height: 32px;
  background-image: url(${closeIcon});
  background-color: transparent;
  background-size: 100% 100%;
`;

const ColorPickerHeader = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 0px;
  margin-bottom: 10px;
`;

const ColorPreview = styled.div`
  display: inline-block;
  margin: 0px;
  width: 70px;
  height: 25px;
  border-radius: 0px;
  background-color: ${(props) => props.backgroundColor};
  border: 0.5px #000000 solid;
`;

const ColorInput = styled.input`
  width: 100%;
  height: 25px;
  font-size: 11px;
  border-radius: 0px !important;
  border: 0.5px #c4c4c4 solid !important;
  outline: none;
`;

const RadiusButton = styled.div`
  display: flex;
  flex-direction: column;
  width: 65px;
  height: 65px;
  margin-right: 20px;
  color: #b5b5b5;
  text-align: center;
  font-size: 12px;
  color: ${(props) => (props.selected ? '#FFB600' : '#b5b5b5')};
  cursor: pointer;
`;

export default DesignPreviewPage;
